var map = {
	"./asset-hyperlink.json": 7910,
	"./blockquote.json": 6800,
	"./document.json": 9778,
	"./embedded-asset-block.json": 1524,
	"./embedded-entry-block.json": 4872,
	"./embedded-entry-inline.json": 1458,
	"./embedded-resource-block.json": 1944,
	"./embedded-resource-inline.json": 6898,
	"./entry-hyperlink.json": 150,
	"./heading-1.json": 9521,
	"./heading-2.json": 1956,
	"./heading-3.json": 263,
	"./heading-4.json": 3274,
	"./heading-5.json": 149,
	"./heading-6.json": 5288,
	"./hr.json": 9189,
	"./hyperlink.json": 5451,
	"./list-item.json": 9757,
	"./ordered-list.json": 723,
	"./paragraph.json": 4927,
	"./resource-hyperlink.json": 8368,
	"./table-cell.json": 524,
	"./table-header-cell.json": 4124,
	"./table-row.json": 6516,
	"./table.json": 4473,
	"./text.json": 4076,
	"./unordered-list.json": 1984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7688;